export default {
    label: {
        on: 'Automatic transfer of all Trendone trend universe updates active',
        off: 'Automatic transfer of all Trendone trend universe updates inactive'
    }
}
